import Nullstack from 'nullstack';
export default function IconArrowsDoubleSeNw({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-double-se-nw",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "10",
    x2: "14",
    y2: "21"
  }), "   ", Nullstack.element("path", {
    d: "M14 17v4h-4"
  }), "   ", Nullstack.element("path", {
    d: "M14 3h-4v4"
  }), "   ", Nullstack.element("path", {
    d: "M21 14l-11 -11"
  }), " ");
}